import { useEffect } from "react";
import Footer from "../../Components/Footer/Footer";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import "./legal.css";
import SEOHead from "../../Components/SEOHead/SEOHead";
import { getSEOByPath } from "../../config/seoConfig";

const PrivacyPolicy = () => {
  const seoData = getSEOByPath("/privacy-policy");
  
  useEffect(() => {
    window.scrollTo(0, 0); // This will scroll the page to the top
  }, []);

  return (
    <div className="legal_container">
      {seoData && (
        <SEOHead 
          title={seoData.title}
          description={seoData.description}
          canonical={seoData.canonical}
        />
      )}
      <HomeNavbar isHome={true} />
      {/* <div className="main_home_wrapper"> */}
      <div className="legal_content">
        <h1 className="legal_heading">Privacy Policy</h1>
        <div className="legal_wrapper">
          This policy (together with our terms of use
          http://tascoutsourcing.com/terms-conditions/ and any other documents
          referred to on it) sets out the basis on which any personal data we
          collect from you, or that you provide to us, will be processed by us.
          Please read the following carefully to understand our views and
          practices regarding your personal data and how we will treat it.
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">
            We may collect and process the following data about you:
          </h2>
          <p>
            Information that you provide by filling in forms on our site
            http://tascoutsourcing.com (our site). This includes information
            provided at the time of registering to use our site, subscribing to
            our service, posting material or requesting further services. We may
            also ask you for information when you report a problem with our
            site.
          </p>
          <p>If you contact us, we may keep a record of that correspondence.</p>
          <p>
            We may also ask you to complete surveys that we use for research
            purposes, although you do not have to respond to them.
          </p>
          <p>
            Details of transactions you carry out through our site and of the
            fulfilment of your orders.
          </p>
          <p>
            Details of your visits to our site [including, but not limited to,
            traffic data, location data, weblogs and other communication data,
            whether this is required for our own billing purposes or otherwise]
            and the resources that you access.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">IP addresses and cookies </h2>
          <p>
            We may collect information about your computer, including where
            available your IP address, operating system and browser type, for
            system administration and to report aggregate information to our
            advertisers. This is statistical data about our users’ browsing
            actions and patterns, and does not identify any individual.
          </p>
          <p>
            For the same reason, we may obtain information about your general
            internet usage by using a cookie file which is stored on the hard
            drive of your computer. Cookies contain information that is
            transferred to your computer’s hard drive. They help us to improve
            our site and to deliver a better and more personalised service. They
            enable us:
          </p>
          <ul>
            <li>To estimate our audience size and usage pattern.</li>
            <li>
              To store information about your preferences, and so allow us to
              customise our site according to your individual interests.
            </li>
            <li>To speed up your searches.</li>
            <li>To recognise you when you return to our site.</li>
          </ul>
          <p>
            You may refuse to accept cookies by activating the setting on your
            browser which allows you to refuse the setting of cookies. However,
            if you select this setting you may be unable to access certain parts
            of our site. Unless you have adjusted your browser setting so that
            it will refuse cookies, our system will issue cookies when you log
            on to our site.
          </p>
          <p>
            Please note that our advertisers may also use cookies, over which we
            have no control.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">
            Where we store your personal data{" "}
          </h2>
          <p>
            The data that we collect from you may be transferred to, and stored
            at, a destination outside the European Economic Area (“EEA”). It may
            also be processed by staff operating outside the EEA who work for us
            or for one of our suppliers. Such staff maybe engaged in, among
            other things, the fulfilment of your order, the processing of your
            payment details and the provision of support services. By submitting
            your personal data, you agree to this transfer, storing or
            processing. We will take all steps reasonably necessary to ensure
            that your data is treated securely and in accordance with this
            privacy policy.
          </p>
          <p>
            Where we have given you (or where you have chosen) a password which
            enables you to access certain parts of our site, you are responsible
            for keeping this password confidential. We ask you not to share a
            password with anyone.
          </p>

          <p>
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we will do our best to protect your
            personal data, we cannot guarantee the security of your data
            transmitted to our site; any transmission is at your own risk. Once
            we have received your information, we will use strict procedures and
            security features to try to prevent unauthorised access.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Uses made of the information</h2>
          <p>We use information held about you in the following ways:</p>
          <ul>
            <li>
              To ensure that content from our site is presented in the most
              effective manner for you and for your computer.
            </li>
            <li>
              To provide you with information, products or services that you
              request from us or which we feel may interest you, where you have
              consented to be contacted for such purposes.
            </li>
            <li>
              To carry out our obligations arising from any contracts entered
              into between you and us.
            </li>
            <li>
              To allow you to participate in interactive features of our
              service, when you choose to do so.
            </li>
            <li>To notify you about changes to our service.</li>
          </ul>
          <p>
            We may also use your data, or permit selected third parties to use
            your data, to provide you with information about goods and services
            which may be of interest to you and we or they may contact you about
            these by [post or telephone].
          </p>

          <p>
            If you are an existing customer, we will only contact you by
            electronic means (e-mail or SMS) with information about goods and
            services similar to those which were the subject of a previous sale
            to you.
          </p>
          <p>
            If you are a new customer, and where we permit selected third
            parties to use your data, we (or they) will contact you by
            electronic means only if you have consented to this.
          </p>
          <p>
            If you do not want us to use your data in this way, or to pass your
            details on to third parties for marketing purposes, please contact
            us.
          </p>
          <p>
            We do not disclose information about identifiable individuals to our
            advertisers, but we may provide them with aggregate information
            about our users (for example, we may inform them that 500 men aged
            under 30 have clicked on their advertisement on any given day). We
            may also use such aggregate information to help advertisers reach
            the kind of audience they want to target (for example, women in
            SW1). We may make use of the personal data we have collected from
            you to enable us to comply with our advertisers’ wishes by
            displaying their advertisement to that target audience.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Disclosure of your information</h2>
          <p>
            We may disclose your personal information to any member of our
            group, which means our subsidiaries, our ultimate holding company
            and its subsidiaries.
          </p>
          <p>We may disclose your personal information to third parties:</p>
          <ul>
            <li>
              In the event that we sell or buy any business or assets, in which
              case we may disclose your personal data to the prospective seller
              or buyer of such business or assets.
            </li>
            <li>
              If TASC Outsourcing or substantially all of its assets are
              acquired by a third party, in which case personal data held by it
              about its customers will be one of the transferred assets.
            </li>
            <li>
              If we are under a duty to disclose or share your personal data in
              order to comply with any legal obligation, or in order to enforce
              or apply our terms of use (terms) or to protect the rights,
              property, or safety of TASC Outsourcing, our customers, or others.
              This includes exchanging information with other companies and
              organisations for the purposes of fraud protection and credit risk
              reduction.
            </li>
          </ul>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Your rights</h2>
          <p>
            You have the right to ask us not to process your personal data for
            marketing purposes. We will usually inform you (before collecting
            your data) if we intend to use your data for such purposes or if we
            intend to disclose your information to any third party for such
            purposes. You can exercise your right to prevent such processing by
            checking certain boxes on the forms we use to collect your data. You
            can also exercise the right at any time by contacting us at
            info@tascoutsourcing.com Our site may, from time to time, contain
            links to and from the websites of our partner networks, advertisers
            and affiliates. If you follow a link to any of these websites,
            please note that these websites have their own privacy policies and
            that we do not accept any responsibility or liability for these
            policies. Please check these policies before you submit any personal
            data to these websites.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Changes to our privacy policy</h2>
          <p>
            Any changes we may make to our privacy policy in the future will be
            posted on this page and, where appropriate, notified to you by
            e-mail.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Contact</h2>
          <p>
            Questions, comments and requests regarding this privacy policy are
            welcomed and should be addressed to info@tascoutsourcing.com
          </p>
        </div>
        {/* <div className="footer_section">
        <div>
          © Copyright 2024{" "}
          <a
            href="https://tascoutsourcing.com/en"
            target="_blank"
            className="white_link"
          >
            TASC Outsourcing
          </a>
          . All rights reserved
        </div>
        <div className="privacy_container">
          <a
            href="https://falektayyeb.ae/privacy-policy"
            target="_self"
            className="white_link"
          >
            Privacy Policy
          </a>
          <a
            href="https://falektayyeb.ae/terms-of-use"
            className="white_link"
            target="_self"
          >
            Terms Of Use
          </a>
        </div>
      </div> */}
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
